import { DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface ReminderDialogFooterProps {
  onCancel: () => void;
  onSchedule: () => void;
}

export const ReminderDialogFooter = ({ onCancel, onSchedule }: ReminderDialogFooterProps) => {
  return (
    <DialogFooter>
      <div className="flex gap-2 w-full">
        <Button
          variant="outline"
          onClick={onCancel}
          className="flex-1"
        >
          Cancel
        </Button>
        <Button
          onClick={onSchedule}
          className="flex-1"
        >
          Schedule Post
        </Button>
      </div>
    </DialogFooter>
  );
};